// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LeftMenu":"ir_a bhn_tr","LeftMenu__link":"ir_b bhn_vt bhn_a bhn_rc","LeftMenu__link__icon":"ir_c"};